<div class="modal-wrapper">
  <h1 class="title">{{ 'users.creating-form.title' | translate | uppercase }}</h1>

  <div class="form-field">
    <mat-form-field>
      <input
        type="email"
        matInput
        [formControl]="emailControl"
        (keydown.enter)="search()"
        placeholder="{{ 'users.fields-placeholders.email' | translate }}"
      />
    </mat-form-field>
  </div>

  <div class="form-actions">
    <button class="cancel-button" [mat-dialog-close]="null"
            mat-button>{{ "system.cancel" | translate | uppercase }}</button>
    <button class="add-button" [disabled]="emailControl.invalid" mat-raised-button
            (click)="search()">
      {{ 'system.next' | translate | uppercase}}
    </button>
  </div>
</div>
